import { render, staticRenderFns } from "./ArchiveTaskModal.vue?vue&type=template&id=1c1bf4fb&scoped=true&"
import script from "./ArchiveTaskModal.vue?vue&type=script&lang=ts&"
export * from "./ArchiveTaskModal.vue?vue&type=script&lang=ts&"
import style0 from "./ArchiveTaskModal.vue?vue&type=style&index=0&id=1c1bf4fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1bf4fb",
  null
  
)

export default component.exports